import { useMemo } from 'react';

import { RoleMenu, RoleMenuOption } from '../../../../../components/MembersTable/RoleMenuCell';
import { TeamMemberDataType } from '../../TeamMembersTable';
import { useGetRole } from '../../../../../../helpers/useGetRole';
import { OrganisationTeamRole } from '../../../../../../__generated__/types';

interface RoleCellProps {
	row: TeamMemberDataType;
	onRoleChange?: (memberId: string, teamRole: OrganisationTeamRole) => void;
}

const options: RoleMenuOption<OrganisationTeamRole>[] = [
	{
		title: 'Team Admin',
		value: OrganisationTeamRole.Admin,
	},
	{ title: 'Caregiver', value: OrganisationTeamRole.Member },
];

export const TeamRoleCell = ({ row, onRoleChange }: RoleCellProps) => {
	const { getTeamRoleString } = useGetRole();

	const currentOption = useMemo(
		() => ({
			title: getTeamRoleString(row.role, row.teamRole),
			value: row.teamRole,
		}),
		[getTeamRoleString, row.role, row.teamRole],
	);

	return (
		<RoleMenu
			options={options}
			currentOption={currentOption}
			disabled={!onRoleChange}
			onRoleChange={(value) => onRoleChange?.(row.memberId, value)}
		/>
	);
};
